import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setLiveFilterInfo } from 'reduxModules/live/action';
import { sendGTMEvent } from 'reduxModules/googleTagManager/action';
import {
  REGULAR_CLASS_GRADE_LEVEL_CLICK,
  REGULAR_CLASS_SUBJECT_CLICK,
} from 'constants/gtmEvent';

const SELECT_ALL_ID = 0;

export default function useOnFilterChange(filterName) {
  const dispatch = useDispatch();

  const onFilterChange = useCallback(
    ({ id, name }) => {
      dispatch(
        setLiveFilterInfo({
          [filterName]: id,
        }),
      );

      if (filterName === 'selectedGradeLevel' && id !== SELECT_ALL_ID) {
        dispatch(
          sendGTMEvent({
            eventName: REGULAR_CLASS_GRADE_LEVEL_CLICK,
            data: { gradeLevelId: id, gradeLevelName: name },
          }),
        );
      }

      if (filterName === 'selectedSubject' && id !== SELECT_ALL_ID) {
        dispatch(
          sendGTMEvent({
            eventName: REGULAR_CLASS_SUBJECT_CLICK,
            data: { subjectId: id, subjectTitle: name },
          }),
        );
      }
    },
    [dispatch, filterName],
  );

  return onFilterChange;
}
